import './App.css';
import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase-config';

import Header from './components/Header';
import HeroSection from './components/HeroSection/HeroSection';
import OlaSection from './components/OlaSection/OlaSection';
import FeatureSection from './components/FeatureSection/FeatureSection';
import ServicesSection from './components/ServicesSection/ServicesSection';
import ExploreSection from './components/ExploreSection/ExploreSection';
import ContactSection from './components/ContactSection/ContactSection';
import FooterSection from './components/FooterSection/FooterSection';
import SaybicDashboard from './components/SaybicInnovation/SaybicDashboard';
import ContactCard from './components/ContactCard/ContactCard';
import TsContasolLanding from './components/TsContasolLanding/TsContasolLanding';
import EcommerceAuditLanding from './components/EcommerceAuditLanding/EcommerceAuditLanding';
import PartnerAgenciesLanding from './components/PartnerAgenciesLanding/PartnerAgenciesLanding';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import ClientLogin from './components/ClientLogin/ClientLogin';
import ClientSelector from './components/ClientPortal/ClientSelector';
import MotoWebDashboard from './components/MotoWebLasPalmas/MotoWebDashboard';
import {
  CLIENT_LOGIN_PATH,
  CLIENT_PORTAL_PATH,
  CLIENTS,
  isAdmin,
  isAuthorizedForClient
} from './config/clientAccess';

function App() {
  const [user, setUser] = useState(null);
  const [authReady, setAuthReady] = useState(false);
  const path = window.location.pathname;

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setAuthReady(true);
    });
    return () => unsubscribe();
  }, []);

  const renderAuthLoading = () => (
    <main className="client-login-page" aria-live="polite">
      <div className="client-auth-loader" role="status">
        <span className="client-auth-spinner" aria-hidden="true" />
        <p>Comprobando sesión…</p>
      </div>
    </main>
  );

  if (path === CLIENT_LOGIN_PATH) {
    return (
      <div className="App">
        {authReady ? <ClientLogin user={user} /> : renderAuthLoading()}
      </div>
    );
  }

  if (path === CLIENT_PORTAL_PATH) {
    if (!authReady) {
      return <div className="App">{renderAuthLoading()}</div>;
    }

    if (!user) {
      window.location.replace(CLIENT_LOGIN_PATH);
      return <div className="App">{renderAuthLoading()}</div>;
    }

    return (
      <div className="App">
        {isAdmin(user)
          ? <ClientSelector user={user} />
          : <ClientLogin user={user} accessDenied />}
      </div>
    );
  }

  if (path === CLIENTS.motowebLasPalmas.path) {
    if (!authReady) {
      return <div className="App">{renderAuthLoading()}</div>;
    }

    if (!user) {
      window.location.replace(CLIENT_LOGIN_PATH);
      return <div className="App">{renderAuthLoading()}</div>;
    }

    const hasMotoWebAccess = isAuthorizedForClient(
      user,
      CLIENTS.motowebLasPalmas
    );

    return (
      <div className="App">
        {hasMotoWebAccess
          ? <MotoWebDashboard user={user} />
          : <ClientLogin user={user} accessDenied />}
      </div>
    );
  }

  if (path === CLIENTS.saybicInnovation.path) {
    if (!authReady) {
      return <div className="App">{renderAuthLoading()}</div>;
    }

    if (!user) {
      window.location.replace(CLIENT_LOGIN_PATH);
      return <div className="App">{renderAuthLoading()}</div>;
    }

    const hasSaybicAccess = isAuthorizedForClient(
      user,
      CLIENTS.saybicInnovation
    );

    return (
      <div className="App">
        {hasSaybicAccess
          ? <SaybicDashboard user={user} portalMode />
          : <ClientLogin user={user} accessDenied />}
      </div>
    );
  }

  // Compatibilidad con enlaces antiguos de SayBiC.
  if (path === '/saybic-innovation') {
    window.location.replace(CLIENTS.saybicInnovation.path);
    return <div className="App">{renderAuthLoading()}</div>;
  }

  // Ruta tarjeta de contacto
  if (path === '/contact-card') {
    return (
      <div className="App">
        <ContactCard />
      </div>
    );
  }

  if (path === '/ts-contasol') {
    return (
      <div className="App">
        {/* Wrapper que actuará como reseteador de estilos */}
        <div className="ts-contasol-wrapper">
          <TsContasolLanding />
          <FooterSection />
        </div>
      </div>
    );
  }

  if (path === '/auditoria-ecommerce') {
    return (
      <div className="App">
        <EcommerceAuditLanding />
      </div>
    );
  }

  if (path === '/partner-agencias') {
    return (
      <div className="App">
        <PartnerAgenciesLanding />
      </div>
    );
  }

  if (path === '/politica-privacidad') {
    return (
      <div className="App">
        <PrivacyPolicy />
      </div>
    );
  }

  return (
    <div className="App">
      <div className='main-content'>
        <div className='container-fluid'>
          <div className='custom-container px-lg-5 px-md-4 px-sm-2'>
            <div className='row'>
              <div className='col-12'>
                <Header />
              </div>
            </div>
          </div>
          <div className='col-lg-12'>
            <HeroSection />
          </div>
          <div className='col-lg-12'>
            <OlaSection />
          </div>
          <div className='col-lg-12'>
            <FeatureSection />
          </div>
          <div className='col-lg-12'>
            <ServicesSection />
          </div>
          <div className='col-lg-12'>
            <ExploreSection />
          </div>
          <div className='col-lg-12'>
            <ContactSection />
          </div>
          <div className='col-lg-12'>
            <FooterSection />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
